
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/daymade-named-one-of-europes-fastest-growing-companies-by-financial-times",
      function () {
        return require("private-next-pages/blog/daymade-named-one-of-europes-fastest-growing-companies-by-financial-times.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/daymade-named-one-of-europes-fastest-growing-companies-by-financial-times"])
      });
    }
  